export class CartesianMappingProduct {
  /**
   * Given a data object with 1 or more keys, each containing an array of values,
   * this method generates all possible combinations of those values, retaining mapping of key to value.
   *
   * @param {{[key: string]: Object[]}} data
   * @returns {Array<{[key: string]: Object}>}
   */
  static getProduct(data) {
    // Validate all keys exist as placeholders
    const dataMappings = [];
    for (let i = 0; i < Object.keys(data).length; i++) {
      const key = Object.keys(data)[i];
      const values = data[key];
      if (i === 0) {
        for (const value of values) {
          dataMappings.push({ [key]: value });
        }
      } else {
        const toAdd = [];
        for (const dataMapping of dataMappings) {
          for (let j = 0; j < values.length; j++) {
            const value = values[j];
            if (j === 0) {
              // If it's the first value, we just add it to the existing mapping
              dataMapping[key] = value;
            } else {
              // Create a new object for each combination
              const newMapping = { ...dataMapping, [key]: value };
              toAdd.push(newMapping);
            }
          }
        }
        dataMappings.push(...toAdd);
      }
    }
    return dataMappings;
  }
}
